import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { HtmlContent } from "../../../HtmlContent";
import styles from "./Error.style";

const ErrorStyled = styled.div((props) => ({ ...styles(props) }));

const Error = ({ error, errorMessage, className, ...rest }) => {
    if (!error || !errorMessage) {
        return null;
    }

    return (
        <ErrorStyled className={className} role="alert" {...rest}>
            <HtmlContent
                content={errorMessage}
                className="inputErrorInner"
                wrapperComponent="div"
            />
        </ErrorStyled>
    );
};

Error.propTypes = {
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
};

Error.defaultProps = {
    error: false,
    errorMessage: undefined,
    className: undefined,
};

export default Error;
